@use '@lib/assets/styles/main.scss' as *;

.modalContentClassName {
  padding-top: 0;
  padding-bottom: 0;
}

.modalBodyClassName {
  padding: 0;
}
